<template>
  <b-card>
    <template #header>
      <span>{{ formItem.dashboardName }}</span>
      <b-icon-x
        variant="primary"
        class="clickable float-right"
        font-scale="1.8"
        @click="exitBuilder"
      />
      <b-icon-gear-fill
        v-if="formItem.id !== null && formItem.owner === currentUser.name"
        variant="primary"
        class="clickable float-right mr-1"
        font-scale="1.2"
        shift-v="-4"
        @click="editMode = !editMode"
        title="toggle edit mode"
      />
    </template>
    <b-row class="mb-3">
      <b-col>
        <div>
          <section v-if="isInEditMode">
            <b-form ref="main-form">
              <b-row class="mb-3">
                <b-col cols="6" lg="2">
                  <label>Report Name</label>
                </b-col>
                <b-col cols="6" lg="3">
                  <b-input
                    v-model="formItem.dashboardName"
                    size="sm"
                    required
                  ></b-input>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-button
                    size="sm"
                    variant="primary"
                    class="float-right"
                    :disabled="chartReport.charts.length === 0"
                    @click="submitChartReport"
                  >
                    <b-icon-pencil shift-v="-2" font-scale="1.2" />
                    {{ chartReport.id ? 'Edit' : 'Create' }}
                  </b-button>
                  <b-button
                    class="float-right mr-1"
                    size="sm"
                    @click="deleteChartReport"
                    v-if="this.formItem.id"
                  >
                    <b-icon-trash shift-v="-2" font-scale="1.2" />
                    Delete
                  </b-button>
                </b-col>
              </b-row>
              <!--      <b-row class="mb-3">-->
              <!--        <b-col cols="6" lg="2">-->
              <!--          <label>Is Private?</label>-->
              <!--        </b-col>-->
              <!--        <b-col cols="6" lg="3">-->
              <!--          <b-checkbox-->
              <!--              v-model="formItem.isPrivate"-->
              <!--              :value="true"-->
              <!--              :unchecked-value="false"-->
              <!--          />-->
              <!--        </b-col>-->
              <!--      </b-row>-->
            </b-form>
            <hr />
            <b-row class="mb-3">
              <b-col>
                <b-button
                  size="sm"
                  @click="chartCreateModal = true"
                  variant="outline-primary"
                  >Add Chart
                </b-button>
              </b-col>
            </b-row>
          </section>

          <b-row class="mb-3">
            <b-col
              cols="12"
              :md="chart.width || 6"
              v-for="(chart, index) in formItem.charts"
              :key="index"
            >
              <b-card class="mb-3">
                <template v-if="isInEditMode" #header>
                  <b-icon-x
                    class="clickable float-right"
                    font-scale="1.2"
                    @click="
                      formItem.charts.splice(formItem.charts.indexOf(chart), 1)
                    "
                    title="remove chart"
                  />
                  <b-icon-gear-fill
                    class="clickable float-right mr-1"
                    font-scale="0.8"
                    shift-v="-4"
                    @click="loadChartForEdit(chart, index)"
                    title="edit chart"
                  />
                </template>
                <chart-component :chart-settings="chart" />
              </b-card>
            </b-col>
          </b-row>
          <b-row v-if="isInEditMode">
            <b-col>
              <b-button
                v-if="isInEditMode"
                size="sm"
                variant="primary"
                class="float-right"
                :disabled="chartReport.charts.length === 0"
                @click="submitChartReport"
                >{{ chartReport.id ? 'Edit' : 'Create' }}
              </b-button>
            </b-col>
          </b-row>

          <b-modal v-model="chartCreateModal" size="lg" hide-footer scrollable>
            <b-row>
              <b-col class="px-5">
                <chart-builder :datasets="datasets" @addChart="addChart" />
              </b-col>
            </b-row>
          </b-modal>

          <b-modal v-model="chartEditModal" size="lg" hide-footer scrollable>
            <b-row>
              <b-col class="px-5">
                <chart-builder
                  :datasets="datasets"
                  :chart-settings="selectedChart"
                  @editChart="editChart"
                />
              </b-col>
            </b-row>
          </b-modal>
        </div>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
/*global _*/
import ChartBuilder from '@/components/charts/ChartBuilder';
import ChartComponent from '@/components/charts/ChartComponent';
import application from '@/mixins/application';

export default {
  name: 'ChartReportBuilder',
  mixins: [application],
  components: { ChartBuilder, ChartComponent },
  props: {
    datasets: Array,
    chartReport: {
      type: Object,
      default: () => {
        return { charts: [] };
      },
    },
  },
  data() {
    return {
      chartCreateModal: false,
      chartEditModal: false,
      formItem: {
        dashboardName: '',
        isPrivate: true,
        charts: [],
      },
      selectedChart: {},
      editMode: false,
      selectedDatasets: [],
    };
  },
  mounted() {
    this.formItem = this.chartReport;
  },
  watch: {
    chartReport: {
      deep: true,
      handler(newVal) {
        this.formItem = newVal;
      },
    },
  },
  computed: {
    dragOptions() {
      return {
        animation: 100,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost',
      };
    },
    isInEditMode() {
      return this.editMode || this.formItem.id === null;
    },
    sortedCharts() {
      const charts = _.cloneDeep(this.formItem.charts);
      _.each(charts, chart => {
        if (!chart.width) {
          chart.width = 6;
        }
      });
      return _.sortBy(charts, chart => {
        return chart.index ?? 0;
      });
    },
  },
  methods: {
    exitBuilder() {
      this.$emit('exitBuilder');
    },
    addChart(chart) {
      this.chartCreateModal = false;
      this.formItem.charts.push(chart);
    },
    loadChartForEdit(chart, index) {
      const selectedChart = _.cloneDeep(chart);
      selectedChart.index = index;
      this.selectedChart = selectedChart;
      this.chartEditModal = true;
    },
    editChart(chart, index) {
      this.chartEditModal = false;
      this.$set(this.formItem.charts, index, chart);
    },
    submitChartReport() {
      const mainForm = this.$refs['main-form'];
      if (!mainForm.reportValidity()) {
        return;
      }
      const message = this.formItem.id
        ? 'Proceed to edit the report?'
        : 'Proceed to create the report?';
      this.$bvModal.msgBoxConfirm(message, { centered: true }).then(confirm => {
        if (confirm) {
          this.$emit('submitChartReport', this.formItem);
        }
      });
    },
    deleteChartReport() {
      this.$bvModal
        .msgBoxConfirm('Proceed to delete the report?', { centered: true })
        .then(confirm => {
          if (confirm) {
            this.$emit('deleteChartReport', this.formItem.id);
          }
        });
    },
  },
};
</script>

<style scoped></style>